// src/index.js
import React, { Suspense } from 'react'; // <-- MODIFICA: Importa Suspense
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './race_engineer_print.css';

// --- MODIFICA: Importa la configurazione i18n ---
// Questo avvia i18next
import './i18n';
// --- FINE MODIFICA ---

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* --- MODIFICA: Aggiungi il wrapper Suspense --- */}
    {/* Serve a i18next per caricare i file JSON della lingua */}
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
    {/* --- FINE MODIFICA --- */}
  </React.StrictMode>
);